/** @jsx jsx */
import { jsx } from '@emotion/react'
import { Fragment } from 'react'
import { educacaoInfantilStyle, diferenciaisStyle } from '../assets/styles/InternasContent.styles'
import { Col, Container, Row } from 'react-bootstrap'
import SliderEnsinoFundamental from '@/components/SliderEducacaoFundamental';
import BgEnsinoFundamental from '../assets/images/LP-arabe/bg-ensino-fundamental.svg'
import BgEnsinoFundamentalM from '../assets/images/LP-arabe/bg-ensino-fundamental-m.svg'
import ImgDiferencial1 from '../assets/images/LP-arabe/ef-diferencial-img-1.png'
import ImgDiferencial2 from '../assets/images/LP-arabe/ef-diferencial-img-2.png'

const HeaderContent = () => {
  return (
    <Fragment>
      <section css={educacaoInfantilStyle} style={{ background: '#FFEBD2' }}>
        <Container>
          <Row>
            <Col lg={12} md={12} sm={12}>
              <img src={BgEnsinoFundamental} className="d-none d-md-block" alt='Educação que prepara para liderar e prosperar' />
              <img src={BgEnsinoFundamentalM} className="d-block d-md-none" alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
          <Row className='title-sec'>
            <Col lg={6} md={6} sm={12}>
              <h1>Ensino Fundamental</h1>
              <p className='p-bottom'>com formação acadêmica e ética</p>
            </Col>
            <Col lg={6} md={6} sm={12}>
              <p>No Ensino Fundamental Anos Iniciais, os alunos desenvolvem habilidades cognitivas, emocionais e sociais com base em uma proposta que valoriza a identidade árabe, o raciocínio lógico, a leitura e a convivência. O ensino é pautado pela excelência acadêmica e orientado pelos princípios islâmicos, com foco na autonomia e no pensamento crítico.</p>
            </Col>
          </Row>
        </Container>
      </section>
      <section css={diferenciaisStyle}>
        <Container className='diferencias-sec'>
          <Row data-aos="fade-down" data-aos-delay="500">
            <Col lg={4} md={4} sm={12}>
              <h2>Diferenciais</h2>
              <h3>Ensino Fundamental e Anos Iniciais</h3>
              <p>A Escola Árabe Bertoni une estrutura completa, ensino de excelência e princípios sólidos para formar crianças confiantes, preparadas e conectadas às suas raízes. A convivência diária com a Mesquita, a inserção do árabe no currículo e o cuidado com o desenvolvimento socioemocional são diferenciais que fortalecem a formação integral dos nossos alunos.</p>
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={7} md={7} sm={12}>
              <img src={ImgDiferencial1} alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
          <Row data-aos="fade-down" data-aos-delay="500" className='row-2'>
            <Col lg={4} md={4} sm={12}>
              <img src={ImgDiferencial2} className="d-none d-md-block" alt='Educação que prepara para liderar e prosperar' />
            </Col>
            <Col lg={1} md={1} sm={12} />
            <Col lg={4} md={4} sm={12}>
              <ul>
                <li>- Matemática, língua portuguesa, redação, artes, ciências, história, geografia e educação física</li>
                <li>- Aula de raciocínio matemático </li>
                <li>- Aula de raciocínio matemático</li>
              </ul>
            </Col>
            <Col lg={3} md={3} sm={12}>
              <ul>
                <li>- Material e plataforma online COC</li>
                <li>- Desenvolvimento socioemocional </li>
                <li>- Avaliações formativas </li>
                <li>- Aulas de língua árabe e ensino islâmico</li>
                <li>- Aulas de inglês</li>
              </ul>
            </Col>
            <Col lg={4} md={4} sm={12}>
              <img src={ImgDiferencial2} className="d-block d-md-none row-2" alt='Educação que prepara para liderar e prosperar' />
            </Col>
          </Row>
        </Container>
      </section>
      <SliderEnsinoFundamental />
    </Fragment>

  )
}

export default HeaderContent
